import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import CollegeProfile from './CollegeProfile';
import {getUserInfo} from 'undergraduate-student/actions/user';

const mapStateToProps = ({student}) => ({student});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getUserInfo,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(CollegeProfile);
